export const supportEmail = 'enterprise@terra.money';
export const twitterUrl = 'https://twitter.com/enterprise_dao';
export const mediumUrl = 'https://medium.com/@enterprise_dao';
export const discordUrl = 'https://terra.sc/enterprisediscord';
export const telegramUrl = 'https://terra.sc/enterprisetg';
